/* ============================================================
   InnovaZone Theme JS — minimal, single timeline, GSAP-aware
   Loaded after GSAP + ScrollTrigger CDN (see layout/theme.liquid)
   ============================================================ */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isDesktop    = window.matchMedia('(min-width:761px)').matches;
  const hasGsap      = typeof window.gsap !== 'undefined';
  const hasST        = hasGsap && typeof window.ScrollTrigger !== 'undefined';

  if (hasST) gsap.registerPlugin(ScrollTrigger);

  /* ---------- 1. HEADER SHADOW ON SCROLL ---------- */
  const header = document.getElementById('site-header');
  if (header) {
    let lastY = 0;
    const onScroll = () => {
      const y = window.scrollY || window.pageYOffset;
      if ((y > 50) !== (lastY > 50)) {
        header.classList.toggle('scrolled', y > 50);
      }
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- 2. HERO VIDEO — single scroll-driven fade+scale ---------- */
  /* Single timeline. No sticky pin, no multi-layer parallax, no mouse tilt. */
  const heroContent = document.querySelector('.hero-video__content');
  const heroVideoEl = document.querySelector('.hero-video__video');
  if (hasST && heroContent && !reduceMotion && isDesktop) {
    gsap.to([heroContent], {
      y: -60,
      opacity: 0.15,
      scale: 0.95,
      ease: 'none',
      scrollTrigger: {
        trigger: '.hero-video',
        start: 'top top',
        end: 'bottom top',
        scrub: 0.8
      }
    });
    if (heroVideoEl) {
      gsap.to(heroVideoEl, {
        scale: 1.08,
        ease: 'none',
        scrollTrigger: {
          trigger: '.hero-video',
          start: 'top top',
          end: 'bottom top',
          scrub: 1.2
        }
      });
    }
  }

  /* ---------- 3. INTERSECTION OBSERVER — fade-in sections ---------- */
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    if ('IntersectionObserver' in window && !reduceMotion) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });
      reveals.forEach((el) => io.observe(el));
    } else {
      reveals.forEach((el) => el.classList.add('in'));
    }
  }

  /* ---------- 4. PROMO BANNER DISMISS ---------- */
  const promo = document.getElementById('promo-banner');
  const promoClose = document.querySelector('.promo-banner-close');
  if (promo && promoClose) {
    promoClose.addEventListener('click', () => {
      promo.style.display = 'none';
      try { sessionStorage.setItem('innova:promoClosed', '1'); } catch (e) {}
    });
    try {
      if (sessionStorage.getItem('innova:promoClosed') === '1') {
        promo.style.display = 'none';
      }
    } catch (e) {}
  }

  /* ---------- 5. MOBILE SEARCH TOGGLE ---------- */
  const searchToggle = document.querySelector('.search-mobile');
  const searchEl = document.querySelector('.search');
  if (searchToggle && searchEl) {
    searchToggle.addEventListener('click', () => {
      if (window.innerWidth >= 760) return;
      searchEl.classList.add('search--open');
      const input = searchEl.querySelector('input');
      if (input) {
        input.focus();
        input.addEventListener('blur', () => {
          if (window.innerWidth < 760) searchEl.classList.remove('search--open');
        }, { once: true });
      }
    });
  }

  /* ---------- 6. HERO 2 (ASTRONAUT — optional section) ---------- */
  const astro = document.getElementById('astroImg');
  if (hasST && astro && !reduceMotion && isDesktop) {
    gsap.fromTo(astro,
      { y: 60, rotate: -6, scale: 0.92 },
      {
        y: -40, rotate: 6, scale: 1.04, ease: 'power2.out',
        scrollTrigger: {
          trigger: '.hero2',
          start: 'top 80%',
          end: 'bottom top',
          scrub: 1.2
        }
      }
    );
  }

})();

/* Mobile-search open state — injected via JS, paired with .search class above */
(function injectSearchStyles(){
  const style = document.createElement('style');
  style.textContent = '.search.search--open{display:block;position:absolute;top:12px;left:12px;right:12px;z-index:60;background:#fff;padding:8px;border-radius:14px;box-shadow:0 10px 40px rgba(33,150,208,.18)}';
  document.head.appendChild(style);
})();
